import { useCallback, useEffect, useState } from 'react';
import axiosInstance from '../../../helpers/axios';

export function useInstituteOptions() {
    const [institutes, setInstitutes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const refetch = useCallback(() => {
        setIsLoading(true);
        return axiosInstance
            .get('/institute/info/lite')
            .then((response) => setInstitutes(response.data?.data?.institutes ?? []))
            .catch(() => setInstitutes([]))
            .finally(() => setIsLoading(false));
    }, []);

    useEffect(() => {
        refetch();
    }, [refetch]);

    return { institutes, isLoading, refetch };
}
